import React from 'react';
import logo from '../assets/images/logo.svg';

interface LogoProps {
  className?: string;
  variant?: 'default' | 'white';
}

export function Logo({ className = "h-8", variant = 'default' }: LogoProps) {
  return (
    <img 
      src={logo} 
      alt="DealerDial.ai" 
      className={`${className} ${variant === 'white' ? 'brightness-0 invert' : ''}`}
    />
  );
}